/**
 * @generated SignedSource<<e3efc2d01d48a12e439ca2dd1a3eb81f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type landingPageQuery$variables = {};
export type landingPageQuery$data = {
  readonly viewer: {
    readonly isGuestCheckoutEligible: boolean | null;
  };
};
export type landingPageQuery = {
  response: landingPageQuery$data;
  variables: landingPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuestCheckoutEligible",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "landingPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Viewer",
          "kind": "LinkedField",
          "name": "viewer",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        "action": "THROW",
        "path": "viewer"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "landingPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f97d2b3180b7e38cc208c649b70911fe",
    "id": null,
    "metadata": {},
    "name": "landingPageQuery",
    "operationKind": "query",
    "text": "query landingPageQuery {\n  viewer {\n    isGuestCheckoutEligible\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7e1b3464a67a3090cae892263ce0256c";

export default node;
